import { colors } from 'config';
import { isFitanu } from 'config/theme';

import { Button as BaseButton, styled } from '@material-ui/core';

const BUTTON_WIDTH = 280;
const BUTTON_HEIGHT = 70;
const BUTTON_WIDTH_xs = 160;
const BUTTON_HEIGHT_xs = 32;

export const Button = styled(BaseButton)(({ theme }) => ({
  width: BUTTON_WIDTH,
  height: BUTTON_HEIGHT,
  fontSize: 20,
  borderRadius: isFitanu() ? 0 : 5,
  marginTop: theme.spacing(2),
  boxSizing: "border-box",
  border: isFitanu() ? `2px solid ${theme.palette.common.white}` : "none",
  whiteSpace: "nowrap",
  ...(isFitanu()
    ? {
        backgroundColor: colors.landing.fitanuBlack,
        color: theme.palette.common.white,
        "&:hover": {
          backgroundColor: theme.palette.grey[300],
          color: colors.landing.fitanuBlack,
        },
      }
    : {
        borderRadius: "10px",
        backgroundColor: "#D10A3D",
        color: theme.palette.common.white,
        "&:hover": {
          backgroundColor: theme.palette.common.white,
          color: "#D10A3D",
        },
      }),
  [theme.breakpoints.down("sm")]: {
    width: BUTTON_WIDTH_xs,
    height: BUTTON_HEIGHT_xs,
    fontSize: 15,
  },
}));
